import { useEffect } from 'react';
import { useTranslation } from '../../lib/i18n';
import { getProductSchema } from '../../lib/schema-org';
import { trackProductDetail } from '../../lib/tracking';
import { Related } from '../common/related';
import Layout from '../layout/layout';
import LightBoxContextProvider, { useLightBox } from '../lightbox-context';
import { DefaultTitle, Hero } from '../product/hero';
import { ProductContext } from './product-context';

const Inner = ({
  product,
  related,
  preview,
  children,
  relatedTitle,
  relatedText,
  relatedBtnLink,
  relatedBtnText,
  heroTitle = DefaultTitle,
  bgColor = '#fff',
  titleColor = '#688F68',
  heroClassName = '',
  heroImageAlign = 'text-center lg:text-right',
  heroImageClassName = '',
  showFooter = true,
  showNav = true,
  flyer = false,
}) => {
  const { setImages } = useLightBox();
  const { attrT } = useTranslation();

  useEffect(() => {
    trackProductDetail(product);
    setImages(product.images);
  }, [product.id]);

  return (
    <Layout
      preview={preview}
      title={attrT(product, 'seoTitle')}
      description={attrT(product, 'seoDescription')}
      ldJson={getProductSchema(product)}
      showFooter={showFooter}
      showNav={showNav}
    >
      <ProductContext.Provider value={product}>
        <style>
          {`:root {
      --edvin-title: ${titleColor};
      --edvin-background: ${bgColor};
    }`}
        </style>

        <Hero
          title={heroTitle}
          heroClassName={heroClassName}
          heroImageClassName={heroImageClassName}
          imageAlign={heroImageAlign}
          flyer={flyer}
        />
        {children}
        <Related
          className='mt-20 print:hidden'
          title={relatedTitle}
          text={relatedText}
          btnLink={relatedBtnLink}
          btnText={relatedBtnText}
          items={related}
        />
      </ProductContext.Provider>
    </Layout>
  );
};

const Detail = (props) => (
  <LightBoxContextProvider>
    <Inner {...props} />
  </LightBoxContextProvider>
);

export default Detail;
